import {
	Fragment,
	createRef,
	useEffect,
	useState,
} from "react";
import { Form, Spinner } from "react-bootstrap";

import "./HeadRow.scss";
import {
	getStatusBoolean,
	getStatusCarga,
	getStatusPedidos,
} from "../../../services/Servicos";
import { useSelector } from "react-redux";
import ModalAtualizarDataEntradaVST from "../../modal/ModalAtualizarDataEntradaVST";

export default function HeadTable({
	headerList,
	setArrayFilters = () => {},
	arrayFilters = [],
	setFiltersOld = () => {},
	filtersOld = [],
	arrayValues = [],
	rota = "",
	fn = () => {},
}) {
	// const dateSaida = useRef()
	const [show, setShow] = useState({});
	const [loading, setLoading] = useState({});
	const [dataParam, setDataParam] = useState({
		show: false,
		data_inicial: null,
		data_final: null,
		filtro: "",
	});
	const [position, setPosition] = useState("");

	const user = useSelector((state) => state.userSlice);
	const filiaisList = user.filiaisList.data;
	const funcionariosList = user.funcionariosList.data;
	const onClickFilter = (e, filter, value = "") => {
		setLoading((last) => ({ ...last, [filter]: true }));
		setTimeout(() => {
			setPosition(
				headerList.indexOf(filter) < headerList.length / 2 ? "right" : "left"
			);

			if (!arrayFilters[filter].length) {
				// se ele clicar no filtro e nada estiver cadastrado, coloque as opções
				const teste = new Promise(function (resolve, reject) {
					let elements = [];
					if (["id_filial", "idFilial", "filial",'id_filial_destino'].includes(filter)) {
						elements = arrayValues
							.filter(
								(i, n, s) => s.findIndex((o) => o[filter] === i[filter]) === n
							)
							.map((item) => ({
								show: false,
								value: `${item[filter]} - ${
									filiaisList.filter(
										(itemB) => itemB.idFilial == item[filter]
									)[0]?.identificacaoInterna
								}`, //item[filter]
							}));
						//
					} else if (filter === "caminhoneiro") {
						elements = arrayValues
							.filter(
								(i, n, s) => s.findIndex((o) => o[filter] === i[filter]) === n
							)
							.map((item) => ({
								show: false,
								value: `${item[filter]} - ${
									funcionariosList.find((itemB) => itemB.cpf == item[filter])
										?.name
								}`, //item[filter]
							}));
						//
					} else if (filter === "status" && rota == 'romaneios') {
						elements = arrayValues
							.filter(
								(i, n, s) => s.findIndex((o) => o[filter] === i[filter]) === n
							)
							.map((item) => ({
								show: false,
								value: `${item[filter]} - ${getStatusPedidos(item[filter])
								}`, //item[filter]
							}));
						//
					} else if (filter === "status" && rota == 'cargas') {
						elements = arrayValues
							.filter(
								(i, n, s) => s.findIndex((o) => o[filter] === i[filter]) === n
							)
							.map((item) => ({
								show: false,
								value: `${item[filter]} - ${getStatusCarga(item[filter])
								}`, //item[filter]
							}));
						//
					} else {
						elements = arrayValues
							.filter(
								(i, n, s) => s.findIndex((o) => o[filter] === i[filter]) === n
							)
							.map((item) => ({ show: false, value: item[filter] ?? false }));
					}
					resolve(elements);
				});

				teste.then((response) => {
					setArrayFilters((last) => ({
						...last,
						[filter]: [...last[filter], ...response],
					}));
				});
			}

			Object.keys(show).map((key) => {
				const prom = new Promise((resolve, reject) => {
					if (key == filter) {
						// setShow(last => ({ ...last, [key]: !last[key] }))
						resolve(!show[key]);
					} else {
						// setShow(last => ({ ...last, [key]: true }))
						resolve(true);
					}
				});
				prom.then((response) => {
					setShow((last) => ({ ...last, [key]: response }));
					setLoading((last) => ({ ...last, [filter]: false }));
				});

				// prom.then(response => {

				// })
				// setShow(last => ({ ...last, [key]: true }))

				if (!show[filter]) {
					// se ja estiver aberto, retorne
					setShow((last) => ({ ...last, [filter]: true }));
					return;
				}
			});

			if (String(value).length) {
				if (filtersOld.filter((item) => item[filter] == value).length) {
					alert("item ja filtrado");
					return;
				}
				setFiltersOld((last) => [...last, { [filter]: String(value) }]);
			}
		}, 100);
	};


	const onChangeValueFilter = (e, key) => {
		const value = e.target.value.toUpperCase();

		if (["id_filial", "idFilial", "filial",'id_filial_destino'].includes(key)) {
			setArrayFilters((last) => ({
				...last,
				[key]: last[key].map((item) => {
					if (String(item.value).toUpperCase().includes(value)) {
						item.show = false;
					} else if (
						(item.show !== true) &
						!String(item.value).toUpperCase().includes(value)
					) {
						item.show = true;
					}
					return item;
				}),
			}));
			return;
		}

		setArrayFilters((last) => ({
			...last,
			[key]: last[key].map((item) => {
				// .includes(value))
				if (String(item.value).toUpperCase().includes(value)) {
					item.show = false;
				} else if (
					(item.show !== true) &
					!String(item.value).toUpperCase().includes(value)
				) {
					item.show = true;
				}
				return item;
			}),
		}));
	};

	useEffect(() => {
		headerList
			.filter((item) => item !== "admin")
			.filter((item) => item !== "index")
			.forEach((element) => {
				setArrayFilters((last) => ({ ...last, [element]: [] }));
				setShow((last) => ({ ...last, [element]: true }));
				setLoading((last) => ({ ...last, [element]: false }));
			});
	}, [headerList]);

	return (
		<Fragment>
			<tr style={{ verticalAlign: "middle"}}>
				{headerList.map((item, index) => {
					if (item === "index") {
						return <th key={index}>#</th>;
					}
					if (item === "admin") {
						return <th key={index}>ADMIN</th>;
					}
					if (item === "liberacao_financeiro_file") {
						return <th key={index}>LIBERACAÇÃO FINANCEIRO</th>;
					}
					if (item === "fechamento_financeiro_file") {
						return <th key={index}>FECHAMENTO FINANCEIRO</th>;
					}
					if (item === "previsaoEntrega") {
						return (
							<th key={index}>
								<div
									key={index}
									style={{
										display: "flex",
										alignItems: "baseline",
										zIndex: "1",
									}}
								>
									<div
										style={{
											display: "flex",
											justifyContent: "space-between",
											minWidth: "100%",
										}}
									>
										<div style={{ marginRight: "10px" }}>
											{item.toUpperCase().replaceAll("_", " ")}
										</div>
										<div className="filter-icon">
											<i
												className="bi bi-calendar-date"
												style={{ fontSize: "0.8rem" }}
												title="Editar"
												onClick={(e) =>
													setDataParam((last) => ({
														...last,
														show: true,
														filtro: item,
													}))
												}
											></i>
										</div>
									</div>
								</div>
							</th>
						);
					}
					if (
						item === "data_chegada" ||
						item === "dtemissao" ||
						item === "data" ||
						item === "data_nascimento" ||
						item === "emissao" ||
						item === "ponto_data"
					) {
						return (
							<th key={index}>
								<div
									key={index}
									style={{
										display: "flex",
										alignItems: "baseline",
										zIndex: "1",
									}}
								>
									<div
										style={{
											display: "flex",
											justifyContent: "space-between",
											minWidth: "100%",
										}}
									>
										<div style={{ marginRight: "10px" }}>
											{item.toUpperCase().replaceAll("_", " ")}
										</div>
										<div className="filter-icon">
											<i
												className="bi bi-calendar-date"
												style={{ fontSize: "0.8rem" }}
												title="Editar"
												onClick={(e) =>
													setDataParam((last) => ({
														...last,
														show: true,
														filtro: item,
													}))
												}
											></i>
										</div>
									</div>
								</div>
							</th>
						);
					}
					if (item === "upload_file") {
						return (
							<th key={index} style={{ width: "15%" }}>
								{item.toUpperCase().replaceAll("_", " ")}
							</th>
						);
					}
					if (
						[
							// /cargas
							"peso_total",
							"volume_total",
							"metros_quadrados",
							"qtde_produtos",
							"qtde_pedidos",
							"created_at",
							"updated_at",
							// /plano-logistica/vendas
							"ADMIN",
							"idEmpresa",
							"observacao11",
							"observacao2",
							"observacao3",
							"observacao4",
							"vlrVenda",
							"descbairro",
							"endereco",
							"foneresidencial",
							"fonecelular",
							"foneopcional",
							"nomeRazao",
							"nfeMod",
							"cep",
							"",
							// romaneios
							"empresas_id",
							"qr_code_id",
							"emissao",
							"valor_total",
							// diarios
							"horario",
							"mensagem",
							// rotas
							"createdAt",
							"updatedAt",
							"updatedAt",
							// frota
							"Atribuir",
							"ADMIN",
						].indexOf(item) >= 0
					) {
						return (
							<th key={index}>{item.toUpperCase().replaceAll("_", " ")}</th>
						);
					}
					return (
						<th key={index}>
							<div
								key={index}
								style={{ display: "flex", alignItems: "baseline", zIndex: "1" }}
							>
								<div
									style={{
										display: "flex",
										justifyContent: "space-between",
										minWidth: "100%",
										zIndex: "1",
									}}
								>
									<div style={{ marginRight: "10px" }}>
										{item.toUpperCase().replaceAll("_", " ")}
									</div>
									<div className="filter-icon">
										{loading[item] ? (
											<Spinner size="sm" color="black" animation="border" />
										) : (
											<i
												className="bi bi-funnel-fill"
												style={{ fontSize: "0.8rem" }}
												title="Editar"
												onClick={(e) => onClickFilter(e, item)}
											></i>
										)}
										<ul
											className={`card card-filters-options ${position}`}
											hidden={show[item]}
										>
											<Form.Control
												style={{ padding: "5px", margin: "2px" }}
												onChange={(e) => onChangeValueFilter(e, item)}
											/>
											{arrayFilters[item] &&
												arrayFilters[item]
													// .filter((i, n, s) => s.findIndex(o => o.value === i.value) === n)
													.filter((i) => i.value !== null && i.value !== "")
													.sort((a, b) => {
														if (a.value > b.value) return 1;
														if (a.value < b.value) return -1;
														return 0;
													})
													.filter((item) => !item.show)
													.map((chave, index_) => {
														if (
															/folga|ajuste|feriado|falta|cancelado|encerrado|conferido|carregado|descarregado|is_finalizado_suporte/i.test(
																item
															)
														) {
															return (
																<span
																	key={index_}
																	value={`${chave.value}`}
																	onClick={(e) =>
																		onClickFilter(e, item, chave.value)
																	}
																	hidden={chave.show}
																>
																	{chave.value
																		? "SIM"
																		: chave.value == "null"
																		? "NULL"
																		: "NÃO"}
																</span>
															);
														}
														if (item === "caminhoneiro") {
															return (
																<span
																	key={index_}
																	value={`${chave.value} - ${
																		funcionariosList.find(
																			(item) => item.cpf == chave.value
																		)?.name
																	}`}
																	onClick={(e) =>
																		onClickFilter(e, item, chave.value)
																	}
																	hidden={chave.show}
																>
																	{chave.value}
																</span>
															);
														}
														if (["id_filial", "idFilial", "filial",'id_filial_destino'].includes(item)) {
															return (
																<span
																	key={index_}
																	value={`${chave.value} - ${
																		filiaisList.filter(
																			(item) => item.idFilial == chave.value
																		)[0]?.identificacaoInterna
																	}`}
																	onClick={(e) =>
																		onClickFilter(e, item, chave.value)
																	}
																	hidden={chave.show}
																>
																	{chave.value}
																</span>
															);
														}

														if (index_ < 20) {
															if (
																item === "status" &&
																(rota === "frota" || rota === "funcionarios")
															) {
																return (
																	<span
																		key={index_}
																		value={chave.value}
																		onClick={(e) =>
																			onClickFilter(e, item, chave.value)
																		}
																		hidden={chave.show}
																	>
																		{getStatusBoolean(chave.value)}
																	</span>
																);
															}
															if (item === "status" && rota === "romaneios") {
																return (
																	<span
																		key={index_}
																		value={chave.value}
																		onClick={(e) =>
																			onClickFilter(e, item, chave.value)
																		}
																		hidden={chave.show}
																	>
																		{chave.value}
																	</span>
																);
															}
															if (item === "status" && rota === "cargas") {
																return (
																	<span
																		key={index_}
																		value={chave.value}
																		onClick={(e) =>
																			onClickFilter(e, item, chave.value)
																		}
																		hidden={chave.show}
																	>
																		{chave.value}
																	</span>
																);
															}
															if (item === "stLogistica") {
																return (
																	<span
																		key={index_}
																		value={chave.value}
																		onClick={(e) =>
																			onClickFilter(e, item, chave.value)
																		}
																		hidden={chave.show}
																	>
																		{chave.value}:{" "}
																		{getStatusPedidos(chave.value)}
																	</span>
																);
															}
															return (
																<span
																	key={index_}
																	value={chave.value}
																	onClick={(e) =>
																		onClickFilter(e, item, chave.value)
																	}
																	hidden={chave.show}
																>
																	{chave.value}
																</span>
															);
														}
														// if (indexList < 10) {
														//     setIndexList(setIndexList)
														// }
													})}
										</ul>
									</div>
								</div>
							</div>
						</th>
					);
				})}
			</tr>
			{dataParam.show ? (
				<ModalAtualizarDataEntradaVST
					title={"Filtrar Data"}
					show={dataParam.show}
					setShow={setDataParam}
					{...dataParam}
					setDataParam={setDataParam}
					fn={fn}
				/>
			) : (
				""
			)}
		</Fragment>
	);
}
